import React, {Component} from "react";
import {connect} from "react-redux";
import ReactModal from "react-modal";
import {modalTypes} from "./Modals";
import {modalActions} from "../actions/modal.actions";

const MODAL_TYPES = {
    'alert': modalTypes.AlertModal,
    'confirm': modalTypes.ConfirmModal,
    'deviceInfo': modalTypes.DeviceInfoModal,
    'deviceContentInfo': modalTypes.DeviceContentInfo,
    'formModal': modalTypes.FormModal
};

const mapStateToProps = state => ({
    ...state.modalReducer
});

class ModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: props.modalProps.open ? props.modalProps.open : false,
            large: props.modalProps.large ? props.modalProps.large : false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.modalProps.open !== prevProps.modalProps.open) {
            this.setState({
                modalIsOpen: this.props.modalProps.open,
                large: this.props.modalProps.large
            })
        }
    }

    closeModal = () => {
        this.props.dispatch(modalActions.hideModal());
    };

    render() {
        if(!this.props.modalType) {
            return null
        }
        const SpecifiedModal = MODAL_TYPES[this.props.modalType];

        return (
            <div>
                <ReactModal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                    overlayClassName="modal fade show"
                    bodyOpenClassName="modal-open"
                    className={ this.state.large ? "modal-dialog modal-dialog-centered modal-lg" : "modal-dialog modal-dialog-centered" }
                >
                    <SpecifiedModal
                        closeModal={this.closeModal}
                        {...this.props.modalProps}
                    />
                </ReactModal>
                <div className="modal-backdrop fade show"> </div>
            </div>
        )
    }
}
export default connect(mapStateToProps)(ModalContainer);
